<template>
  <div class="afdc-fuel-filters-box">
    <div class="afdc-row">
      <div class="afdc-col-sm-12">
        <div class="afdc-custom-control afdc-custom-checkbox">
          <input type="checkbox" class="afdc-custom-control-input" v-model="queryLngHasRng" id="afdc-analyze-lng-rng">
          <label class="afdc-custom-control-label" for="afdc-analyze-lng-rng">{{ $t('Include only stations that sell renewable natural gas (RNG)') }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {
  computed: {
    queryLngHasRng: syncInputRouteQuery('lng_has_rng'),
  },
};
</script>

<style lang="scss">
</style>
